<template>
  <div class="common-home-content space_pl space_pr" v-show="show">
    <div class="defalut-survey-title">
      <h3>温馨提示：</h3>
      <p>设置默认问诊单后，患者主动填写问诊单时将自动匹配</p>
    </div>
    <ul class="defalut-survey-ul">
       <li>
        <p>{{people_types[0]}}：{{getDefalutName('tag_man')}}</p>
        <button class="set-defalut" @click="handleSetDefalu(2, 'tag_man', 0)">更换</button>
      </li>
      <li>
        <p>{{people_types[1]}}：{{getDefalutName('tag_women')}}</p>
        <button class="set-defalut" @click="handleSetDefalu(1, 'tag_women', 1)">更换</button>
      </li>
      <li>
        <p>{{people_types[2]}}：{{getDefalutName('tag_child')}}</p>
        <button class="set-defalut" @click="handleSetDefalu(3, 'tag_child', 2)">更换</button>
      </li>
    </ul>
    <van-popup v-model="popup_show" class="defalut-survey-popup" position="bottom" :closeable="true" :safe-area-inset-bottom="true">
      <h3 class="popup-title">{{popup_title}}默认</h3>
      <ul id="survey_ul" class="survey-ul space_pl space_pr">
        <li
          v-for="(child, index) in surveys"
          :key="index"
          @click="saveDefalutSurvey(child)"
        >
          <p class="name"><span class="name-pr">{{child.title}}<span class="default-icon" v-if="defalutMark(child)">{{defalutMark(child)}}</span></span></p>
          <p class="questions">共{{child.question_count}}个问题</p>
        </li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
import {_} from 'vue-underscore';
import http from '../../util/heraApiConfig'
export default {
  data() {
    return {
      show: false,
      popup_show: false,
      token: '',
      surveyDate: {},
      people_type: 1,
      doctor_id: '',
      popup_title: '',
      select_defalut_id: '',
      people_index: 0,
      people_types: ['成人男性', '成人女性', '小儿(0-12周岁)'],
      defalut_surveys: [],
      surveys: [],
      isApp:'',
      platform_type:'',
    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if(this.isApp == "IOS"){
      bridge.callHandler("getUserInfo", "", (response) => {
        this.token = response.token;
        this.doctor_id = response.doctor_id;
        this.platform_type = response.platform_type;
      });
    }else  if (this.isApp == "android") {
      this.$appUtils.showAppTrBtn({});
      var user_info = this.$appUtils.appData();
      if(user_info){
        this.doctor_id = user_info.doctor_id;
        this.token = user_info.token;
        this.platform_type = user_info.platform_type;
      }
    }
    setTimeout(()=>{
      this.getDate();
    },1000)
    window.appBack = ()=> this.pageback();
  },
  methods: {
    defalutMark(item){
      let list = [];
      if(item['tag_women']){
        list.push('成女')
      }
      if(item['tag_man']){
        list.push('成男')
      }
      if(item['tag_child']){
        list.push('小儿')
      }
      if(list.length > 0){
        return list.join('、') + '·默认';
      }else{
        return false;
      }
    },
    getDefalutName(key){
      let that = this;
      let arr = _.filter(that.defalut_surveys, function(item){ return item[key] == 1; });
      if(arr.length > 0){
        return arr[0]['title'];
      }else{
        return '';
      }
    },
    getDate() {
      let that = this;
      let params = {
          doctor_id: that.doctor_id
      }
      http.get("/surveys/default"+'?platform_type=' +this.platform_type, {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          if(res.data.status_code == 200){
            that.defalut_surveys = res.data.data;
          }
          that.show = true;
      });
    },
    handleSetDefalu(type, key, index){
      let that = this;
      that.people_index = index;
      that.people_type = type;
      that.popup_title = that.people_types[index];
      let params = {
          doctor_id: that.doctor_id
      }
      http.get("/surveys/surveys"+'?platform_type=' +this.platform_type, {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          that.system_surveys = res.data.data.system_surveys;
          that.surveys = res.data.data;
          that.popup_show = true;
        setTimeout(function(){
          document.getElementById('survey_ul').scrollTop = 0;
        }, 10);
      });
      let arr = _.filter(that.defalut_surveys, function(item){ return item[key] == 1; });
      if(arr.length > 0){
        that.select_defalut_id = arr[0]['default_id'];
      }else{
        that.select_defalut_id = '';
      }
    },
    saveDefalutSurvey(item){
      let that = this;
      let params = {
          doctor_id: that.doctor_id,
          survey_id: item['survey_id'],
          people_type: that.people_index + 1
      }
      if(that.select_defalut_id){
        params['default_id'] = that.select_defalut_id;
        http.put("/surveys/default"+'?platform_type=' +this.platform_type, params ,{headers: {"Authorization": that.token }
        }).then(function(res) {
          console.log(JSON.stringify(res))
            if(res.data.status_code == 200){
              that.getDate();
              that.popup_show = false;
            }
        });
      }else{
        http.post("/surveys/default"+'?platform_type=' +this.platform_type, params ,{headers: {"Authorization": that.token }
        }).then(function(res) {
            if(res.data.status_code == 200){
              that.getDate();
              that.popup_show = false;
            }
        });
      }
    },
    pageback(){
        window.history.back();
        return true;
    }
  },
};
</script>

<style lang="scss" scoped>
.common-home-content{
  padding-top: 2px;
}
.defalut-survey-title{
  padding: 15px 10px 16px;
  line-height: 21px;
  font-size:14px;
  font-family:PingFang-SC-Medium;
  color:rgba(51,51,51,1);
  background:#FDE4DF;
  border-radius:5px;
}
.defalut-survey-ul{
  margin-top: 25px;
  width: 100%;
  box-sizing: border-box;
  & > li{
    width: 100%;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 10px;
    margin-bottom: 10px;
    padding-right: 32px;
    position: relative;
    p{
      width: 100%;
      box-sizing: border-box;
      padding: 0 10px;
      line-height:50px;
      font-size:16px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow:ellipsis;
    }
    .set-defalut{
      width:28px;
      height:21px;
      font-size:14px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(172,75,56,1);
      line-height:21px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
    }
  }
  & > li:last-child{
    margin-bottom: 10px;
  }
}
.popup-overlay-style{
  background:rgba(0,0,0,1);
  opacity:0.35;
}
.defalut-survey-popup{
  height: 60%;
  padding-top: 48px;
  box-sizing: border-box;
  overflow-y: hidden;
  border-radius: 6px 6px 0 0;
}
.popup-title{
  width: 100%;
  line-height: 48px;
  font-size:16px;
  font-family:PingFang-SC-Bold;
  font-weight:bold;
  text-align: center;
  color:rgba(51,51,51,1);
  position: absolute;
  left: 0;
  top: 0;
}
.survey-ul{
  margin-top: 3px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  & > li{
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 35px 20px 25px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 5px 0px rgba(35,24,21,0.2);
    border-radius:5px;
    position: relative;
    .name{
      line-height: 18px;
      font-size:18px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
      .name-pr{
        display: inline-block;
        position: relative;
      }
      .default-icon{
        display: inline-block;
        padding: 5px 6px;
        line-height:12px;
        font-size:12px;
        font-family: PingFang-SC-Medium;
        font-weight:500;
        color:rgba(188,62,32,1);
        background:rgba(253,236,233,1);
        border-radius:11px;
        position: relative;
        top: -7px;
        right: -5px;
      }
    }
    .questions{
      margin-top: 25px;
      line-height: 14px;
      font-size:14px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(102,102,102,1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/defalutsurvey.vue